import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Row, Col, Container, Card, Image } from 'react-bootstrap'
import sp from '../images/htt500x500.png';
import safetycheck from '../images/safety_check_station.png';
import dotcheck from '../images/dot_inspection_station.png';
import httlogo from '../images/httcrop.png';
function Services() {
    return (
        <div>
            <Image
                src={httlogo}
                alt="background"
                style={{
                    top: 0,
                    left: window.innerWidth < 768 ? '110px' : '30px',
                    height: '75px',
                }}
            />
            <TopMenu />
            <Container>
                <h2 className='htitleb text-center'>Service</h2>
                <p>
                    The HT&T Service Department maintains one of the most fully-equipped shops on Oahu and offers a full range of
                    mechanical, electrical, and body repair services. The Service Department is equipped to service any truck,
                    from a light pickup to a heavy-duty class 8, and we handle all factory authorized warranty repairs on Peterbilt,
                    Isuzu and McNeilus, plus all major OEM components. Utilizing the latest technology to help us identify and
                    fix the problem with greater efficiency, our technicians are trained to work on all makes and models.
                    Service facilities include six covered service bays.</p>
                <Row className=''>
                    <Col md={3}>
                        <Image src={safetycheck} />
                    </Col>
                    <Col md={3}>
                        <Image src={dotcheck} />
                    </Col>
                    <Col md={6}>
                        <h4 className='htitleb text-center'>Service Department</h4>
                        <hr />
                        <Row className='justify-content-center'>
                            <Col md={3}>
                                <h4 className='titleb text-center'>Hours</h4>
                                <p className='text-center'>Monday - Friday <br /> (Closed Weekend) <br /> 7:00 AM - 3:30 PM</p>

                            </Col>
                            <Col md={3}>
                                <h4 className='titleb text-center'>Contact</h4>
                                <p className='text-center'> (808) 532-7512</p>
                            </Col>
                        </Row>
                        <Row>

                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>


                                            Less Down Time
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>Our preventative maintenance program includes an 80-point
                                    inspection to identify and fix any problems that may occur.
                                    This will reduce unexpected breakdowns and help to reduce your down time.
                                    In addition, every time we service a truck we check for any outstanding recalls
                                    issued by the factory and address the issue.
                                    We also process your warranty claims, saving you headaches and, more importantly, time.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                    <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            100% Genuine Peterbilt
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>When you come to HT&T, you can be confident that we know your truck
                                    better than anyone else. We are a Peterbilt exclusive dealer and our
                                    technicians are factory-trained with years of experience working on
                                    trucks just like yours. We use certified OEM parts when we repair your
                                    truck and with Hawaii’s only Peterbilt parts inventory, we have most
                                    parts already in stock so that we can get you back on the road faster.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                </Row>
                <br />
                <Row className='justify-content-center'>
                    <Col md={6} >
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            Unparalleled Service
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>Nowhere else will you find the commitment to service and customer satisfaction
                                    like HT&T Truck Center. At HT&T Truck Center we have three departments ready for your needs.
                                    The Service Department ready to answer questions about what we have to offer, the Truck Sales Department
                                    to let you know what trucks we are selling, and the Parts Department to tell you what parts we have available.
                                </p>
                            </Container>

                        </Card>
                    </Col>
                   
                </Row>
            </Container>
            <br />
            <BottomMenu />
        </div>
    );
}

export default Services;

/*
 <Col md={6}>
                        <Card id="service-card">
                            <Container>
                                <Row>
                                    <Col md={3}>
                                        <Image src={sp} fluid style={{
                                            width: '100%'
                                        }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-center'>
                                        <div className='htitleb' style={{
                                            fontSize: '30px'
                                        }}>
                                            Warranty
                                        </div>
                                    </Col>
                                </Row>
                                <hr></hr>
                                <p>
                                    The HT&T Service Department handles warranty claims for Peterbilt, Isuzu and McNeilus.
                                    The manufacturer guarantees the product to be free from defects in materials and workmanship under normal use conditions for the period specific in the owner's manual, and provide all maintenance requirements are met.
                                    Deficiencies must be brought to the attention of the authorized dealer immediately. All warranty diagnostics and repairs will be performed by our certified technicians.
                                </p>
                            </Container>

                        </Card>
                    </Col>
*/